// src/config/brand-logos.ts
//
// Registro de assets de logo por marca.
//
// Cada marca define un mapa de "variantes". Una variante combina el TIPO de
// logo con el TEMA en el que se va a mostrar:
//
//   Tipo:
//     - full  → logo completo horizontal (con texto). P.ej. navbar / login.
//     - mono  → logo completo en un solo color para recortar sobre fondos de
//               color (sidebar, header del editor). Es la versión que hoy es
//               `logo-blanco.png`.
//     - iso   → isologo / icono cuadrado (solo símbolo). P.ej. sidebar
//               colapsado, HeaderBar del editor, favicon.
//
//   Tema:
//     - light → sobre fondo claro
//     - dark  → sobre fondo oscuro
//
// Así cualquier consumidor pide "el logo full para tema X" sin conocer
// detalles de marca. La resolución (qué archivo clicar) vive aquí.
//
// IMPORTANTE - imports estáticos: los `import` de abajo deben referenced a
// rutas literales (sin variables) para que Vite los analice y los meta en el
// bundle. Reservar AINOVIS arriba para que sea el fallback estático obvio.

// ---- AINOVIS: assets existentes reutilizados ----
import ainovisFullLight from '../assets/logo.png';
import ainovisFullDark from '../assets/logo-blanco.png';
import ainovisMonoLight from '../assets/logo-blanco.png';
import ainovisMonoDark from '../assets/logo-blanco.png';
import ainovisIsoLight from '../assets/ISO-Light Cobalt.png';
import ainovisIsoDark from '../assets/ISO-White.png';

// ---- ALMA MEDICAL: assets que aporta el usuario (convención en assets/alma) ----
import almaFullLight from '../assets/alma/logo-full-light.png';
import almaFullDark from '../assets/alma/logo-full-dark.png';
import almaMonoLight from '../assets/alma/logo-mono-light.png';
import almaMonoDark from '../assets/alma/logo-mono-dark.png';
import almaIsoLight from '../assets/alma/iso-light.png';
import almaIsoDark from '../assets/alma/iso-dark.png';

export type LogoType = 'full' | 'mono' | 'iso';
export type LogoTheme = 'light' | 'dark';

export interface BrandLogos {
  /** Logo completo (con texto), por tema. */
  full: { light: string; dark: string };
  /** Logo monocromo (un solo color) para fondos de color, por tema. */
  mono: { light: string; dark: string };
  /** Isologo / icono cuadrado (solo símbolo), por tema. */
  iso: { light: string; dark: string };
  /** Favicon recomendado (SVG o ICO). Se inyecta en index.html en runtime. */
  favicon: string;
}

/** Registro de logos por marca. */
export const BRAND_LOGOS = {
  AINOVIS: {
    full: { light: ainovisFullLight, dark: ainovisFullDark },
    mono: { light: ainovisMonoLight, dark: ainovisMonoDark },
    iso: { light: ainovisIsoLight, dark: ainovisIsoDark },
    favicon: '/favicon.ico',
  },
  ALMA_MEDICAL: {
    full: { light: almaFullLight, dark: almaFullDark },
    mono: { light: almaMonoLight, dark: almaMonoDark },
    iso: { light: almaIsoLight, dark: almaIsoDark },
    favicon: '/alma/favicon.ico',
  },
} satisfies Record<string, BrandLogos>;

export type BrandLogosMap = typeof BRAND_LOGOS;
